import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDelivery = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.197 15.266a1.917 1.917 0 1 1 0 3.833 1.917 1.917 0 0 1 0-3.833M7.053 15.266a1.917 1.917 0 1 1 0 3.833 1.917 1.917 0 0 1 0-3.833"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.197 15.266V6.98a2.08 2.08 0 0 0-2.08-2.08H5.049C3.918 4.9 3 5.818 3 6.95v8.155a2.08 2.08 0 0 0 2.08 2.08M18.113 17.183h.808A2.08 2.08 0 0 0 21 15.103V11.66c0-.936-.553-1.784-1.41-2.162l-3.393-1.497M18.598 12.41h2.4M8.969 17.183h5.312"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDelivery);
export default ForwardRef;
